import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.references');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-references',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.references/view.scss */
:host {
  container: wb-references/inline-size;
  min-width: 0;
  display: block;
  min-height: 100%;
  color: #172033;
  background: var(--wb-page-canvas, #f5f9fd);
}

.reference-page {
  min-height: 100%;
}

.reference-search-panel {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 10px;
}

.reference-search-top {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 20px;
  min-width: 0;
  margin-bottom: 6px;
}

.reference-search-title-group {
  display: flex;
  align-items: center;
  gap: 18px;
  min-width: 0;
}

.reference-search-title {
  min-width: 0;
}

.reference-content-return {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  width: auto;
  flex: 0 0 auto;
  min-height: 44px;
  padding: 8px 10px;
  border: 1px solid #bae0fa;
  border-radius: 9px;
  background: #fff;
  color: #0369a1;
  font-size: 12px;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
}

.reference-content-return:hover,
.reference-content-return:focus-visible {
  background: #eff8ff;
  border-color: #7dc4f4;
}

.reference-search-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.reference-step-heading {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  min-width: 0;
}

.reference-filter-bar + .reference-step-heading {
  margin-top: 12px;
}

.reference-step-number {
  display: grid;
  flex: 0 0 24px;
  place-items: center;
  width: 24px;
  height: 24px;
  border-radius: 999px;
  background: #e0f2fe;
  color: #0369a1;
  font-size: 12px;
  font-weight: 800;
}

.reference-step-title {
  color: #0f172a;
  font-size: 14px;
  font-weight: 800;
  line-height: 24px;
}

.reference-step-description {
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.reference-feature-suggestions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 7px;
  min-width: 0;
  margin-top: 2px;
}

.reference-feature-caption {
  margin-right: 3px;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
}

.reference-feature-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: 30px;
  padding: 3px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 999px;
  background: #fff;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
}

.reference-feature-chip:hover,
.reference-feature-chip.is-selected {
  border-color: #7dd3fc;
  background: #eaf6fd;
  color: #075985;
}

.reference-feature-chip:focus-visible {
  outline: 2px solid #0369a1;
  outline-offset: 2px;
}

.reference-filter-bar,
.reference-results-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.reference-catalog-totals {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px 14px;
  margin-top: 1px;
  color: #64748b;
  font-size: 12px;
  line-height: 1.5;
}

.reference-catalog-totals strong {
  color: #075985;
  font-weight: 700;
}

.reference-catalog-scope {
  color: #475569;
  font-weight: 700;
}

.reference-search-form {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
  width: 100%;
  min-height: 54px;
  padding: 5px 6px 5px 16px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #fff;
  box-shadow: 0 2px 9px rgba(15, 23, 42, 0.04);
}

.reference-search-form:focus-within {
  border-color: #0369a1;
  box-shadow: 0 0 0 3px rgba(3, 105, 161, 0.1);
}

.reference-search-filter-toggle {
  position: relative;
  display: inline-flex;
  flex: 0 0 42px;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  border-left: 1px solid #e2e8f0;
  border-radius: 8px;
  color: #475569;
  font-size: 15px;
}

.reference-search-filter-toggle:hover,
.reference-search-filter-toggle.is-open,
.reference-search-filter-toggle.has-filters {
  background: #eaf5fc;
  color: #0369a1;
}

.reference-search-filter-toggle:focus-visible {
  outline: 2px solid #0369a1;
  outline-offset: 2px;
}

.reference-search-filter-count {
  position: absolute;
  top: -3px;
  right: -3px;
  display: grid;
  place-items: center;
  min-width: 18px;
  height: 18px;
  padding: 0 3px;
  border: 2px solid #fff;
  border-radius: 999px;
  background: #0369a1;
  color: #fff;
  font-size: 10px;
  font-weight: 700;
  line-height: 1;
}

.reference-purpose-choice {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  min-height: 72px;
  padding: 12px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  color: #334155;
  background: #fff;
  text-align: left;
}

.reference-purpose-choice.is-selected {
  border-color: #0369a1;
  background: #eaf5fc;
  color: #075985;
}

.reference-purpose-choice small {
  color: #64748b;
}

.reference-filter-field {
  display: grid;
  gap: 7px;
  min-width: 0;
  color: #334155;
  font-size: 12px;
  font-weight: 700;
}

.reference-filter-field select,
.reference-filter-field input {
  width: 100%;
  min-height: 44px;
  padding: 0 12px;
  border: 1px solid #cbd5e1;
  border-radius: 10px;
  background: #fff;
  color: #334155;
  font-size: 13px;
  font-weight: 500;
}

.reference-filter-field select {
  appearance: auto;
}

.reference-filter-field select:disabled {
  background: #f8fafc;
  color: #94a3b8;
}

.reference-filter-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid #e2e8f0;
  background: #fff;
}

.reference-search-form input {
  width: 0;
}

.reference-results-toolbar {
  min-height: 52px;
  padding: 4px 0 16px;
  border-bottom: 1px solid #e2e8f0;
  margin-bottom: 18px;
}

@media (min-width: 1024px) and (max-width: 1799px) and (max-height: 1100px) {
  .reference-main {
    max-width: none;
    padding: 20px 24px;
  }
  .reference-main.space-y-5 > :not([hidden]) ~ :not([hidden]) {
    margin-top: 16px;
  }
  .reference-search-panel {
    gap: 8px;
  }
  .reference-search-top {
    gap: 14px;
    margin-bottom: 4px;
  }
  .reference-search-title-group {
    gap: 12px;
  }
  .reference-search-title {
    font-size: 20px;
    line-height: 1.25;
  }
  .reference-content-return {
    min-height: 36px;
    padding: 6px 10px;
    font-size: 11px;
  }
  .reference-step-heading {
    gap: 8px;
  }
  .reference-step-number {
    flex-basis: 20px;
    width: 20px;
    height: 20px;
    font-size: 10px;
  }
  .reference-step-title {
    font-size: 12px;
    line-height: 20px;
  }
  .reference-step-description,
  .reference-catalog-totals {
    font-size: 10px;
  }
  .reference-filter-bar + .reference-step-heading {
    margin-top: 8px;
  }
  .era-button {
    padding: 8px 10px;
    font-size: 12px;
  }
  .reference-search-form {
    gap: 9px;
    min-height: 44px;
    padding: 4px 5px 4px 13px;
  }
  .reference-search-filter-toggle {
    flex-basis: 34px;
    min-height: 34px;
    font-size: 13px;
  }
  .reference-search-form button[type=submit] {
    padding: 8px 16px;
    font-size: 12px;
  }
  .reference-results-toolbar {
    min-height: 42px;
    margin-bottom: 14px;
    padding: 2px 0 12px;
  }
  .reference-result-grid,
  .reference-loading-grid {
    gap: 12px;
  }
  .reference-card-media {
    aspect-ratio: 16/10;
  }
  .reference-card-body {
    padding: 11px;
  }
}
@container wb-references (max-width: 640px) {
  .reference-search-title {
    font-size: 20px;
  }
  .reference-search-top {
    gap: 14px;
  }
  .reference-search-title-group {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }
  .reference-search-panel {
    gap: 10px;
  }
  .reference-search-form {
    gap: 8px;
    padding-left: 12px;
  }
  .reference-results-toolbar {
    align-items: flex-start;
    flex-direction: column;
  }
  .reference-purpose-choice {
    min-height: 64px;
  }
  .reference-filter-footer button[type=submit] {
    flex: 1;
  }
}
@container wb-references (max-width: 360px) {
  .reference-search-top {
    column-gap: 8px;
  }
  .reference-search-title {
    font-size: 17px;
  }
}
.source-card {
  border-color: #e2e8f0;
}

.source-card.is-selected {
  border-color: #6366f1;
  box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.13);
}

.reference-card {
  min-width: 0;
}

.similarity-candidate-list {
  align-content: start;
}

.similarity-dialog-body {
  overflow-y: auto;
}

@container wb-references (max-width: 640px) {
  .similarity-dialog-body {
    flex: 0 0 auto;
    overflow: visible;
  }
}
@container wb-references (min-width: 1280px) {
  .similarity-dialog-body {
    overflow: hidden;
  }
  .similarity-comparison-layout {
    height: 100%;
    min-height: 0;
  }
  .similarity-candidate-panel {
    display: flex;
    min-height: 0;
    flex-direction: column;
    overflow: hidden;
  }
  .similarity-candidate-list {
    min-height: 0;
    flex: 1 1 auto;
    overflow-y: auto;
    overscroll-behavior: contain;
    scrollbar-gutter: stable;
    scrollbar-width: thin;
    scrollbar-color: #cbd5e1 transparent;
  }
  .similarity-candidate-list::-webkit-scrollbar {
    width: 7px;
  }
  .similarity-candidate-list::-webkit-scrollbar-thumb {
    border-radius: 999px;
    background: #cbd5e1;
  }
}
.similarity-candidate {
  border-color: #e2e8f0;
}

.similarity-candidate.is-selected {
  border-color: #7c3aed;
  background: #f5f3ff;
  box-shadow: 0 0 0 2px rgba(124, 58, 237, 0.12);
}

.era-explorer {
  box-shadow: 0 10px 28px rgba(79, 70, 229, 0.06);
}

.era-scroll {
  scrollbar-width: thin;
  scrollbar-color: #c7d2fe transparent;
}

.era-scroll::-webkit-scrollbar {
  height: 5px;
}

.era-scroll::-webkit-scrollbar-thumb {
  background: #c7d2fe;
  border-radius: 999px;
}

.era-button:focus-visible,
.explore-dimension-tab:focus-visible,
.fit-tab:focus-visible,
.reference-card:focus-visible,
.similarity-candidate:focus-visible,
.source-card:focus-visible {
  outline: 3px solid rgba(99, 102, 241, 0.28);
  outline-offset: 2px;
}

.era-button.is-selected,
.explore-dimension-tab.is-selected,
.fit-tab.is-selected {
  transform: translateY(-1px);
}

.explore-dimension-tab.is-selected {
  border-color: #c7d2fe;
  background: #fff;
  color: #4338ca;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.08);
}

.reference-modal {
  animation: reference-fade-in 150ms ease-out;
}

.reference-modal article {
  animation: reference-rise-in 180ms ease-out;
}

.reference-detail-panel {
  scrollbar-gutter: stable;
  scrollbar-width: thin;
  scrollbar-color: #cbd5e1 transparent;
}

.reference-detail-panel::-webkit-scrollbar {
  width: 7px;
}

.reference-detail-panel::-webkit-scrollbar-thumb {
  border-radius: 999px;
  background: #cbd5e1;
}

@container wb-references (min-width: 1024px) {
  .reference-detail-body,
  .reference-detail-media,
  .reference-detail-panel {
    min-height: 0;
  }
  .reference-detail-media {
    overflow: hidden;
  }
  .reference-detail-panel {
    overflow-y: auto;
    overscroll-behavior: contain;
  }
}
@keyframes reference-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes reference-rise-in {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.99);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@media (prefers-reduced-motion: reduce) {
  .reference-modal,
  .reference-modal article,
  .era-button,
  .explore-dimension-tab,
  .fit-tab,
  .source-card,
  .reference-card,
  .similarity-candidate {
    animation: none;
    transition: none;
    transform: none;
  }
}
.reference-result-grid, .reference-loading-grid {
  grid-template-columns: minmax(0, 1fr);
}

.reference-purpose-grid, .reference-filter-grid, .reference-overview-grid, .reference-sources-grid {
  grid-template-columns: minmax(0, 1fr);
}

@container wb-references (min-width: 620px) {
  .reference-result-grid, .reference-loading-grid,
  .reference-purpose-grid, .reference-filter-grid, .reference-overview-grid, .reference-sources-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@container wb-references (min-width: 940px) {
  .reference-result-grid, .reference-loading-grid, .reference-filter-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}
@container wb-references (min-width: 1240px) {
  .reference-result-grid, .reference-loading-grid,
  .reference-overview-grid, .reference-sources-grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }
}
.reference-card-body > div:first-child {
  flex-wrap: wrap;
}

.reference-card-body > div:first-child > p {
  display: block;
  flex: 1 1 12rem;
  overflow: visible;
  -webkit-line-clamp: unset;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.reference-card-caption {
  white-space: normal;
  word-break: keep-all;
  overflow-wrap: anywhere;
}

.reference-filter-field input, .reference-filter-field select {
  min-width: 0;
}

.reference-detail-body {
  grid-template-columns: minmax(0, 1fr);
  overflow-y: auto;
}

@container wb-references (min-width: 1024px) {
  .reference-detail-body {
    grid-template-columns: minmax(0, 1.35fr) minmax(320px, 0.85fr);
    overflow: hidden;
  }
}
@container wb-references (max-width: 640px) {
  .reference-search-top {
    grid-template-columns: minmax(0, 1fr);
  }
  .reference-search-actions {
    justify-content: flex-start;
  }
  .reference-main {
    padding: 20px 12px;
  }
}`],
})
export class PageReferencesComponent implements OnInit, OnDestroy {
    public loading: boolean = true;
    public searching: boolean = false;
    public overviewLoading: boolean = false;
    public errorMessage: string = '';
    public overviewErrorMessage: string = '';
    public rows: any[] = [];
    public overview: any = this.emptyOverview();
    public total: number = 0;
    public page: number = 1;
    public dump: number = 12;
    public previousCursor: string = '';
    public nextCursor: string = '';
    public selected: any = null;
    public similaritySource: any = null;
    public similarityCandidate: any = null;
    public similarityItems: any[] = [];
    public similaritySourceTags: string[] = [];
    public similarityLoading: boolean = false;
    public similarityError: string = '';
    public similaritySummaryLoading: boolean = false;
    public similaritySummaryCount: number | null = null;
    public similaritySummaryError: string = '';
    public similaritySort: 'score' | 'tags' | 'era' | 'region' = 'score';
    public similaritySameEraOnly: boolean = false;
    public similaritySameRegionOnly: boolean = false;
    public similaritySharedTagsOnly: boolean = false;
    public reuseLoadingId: string = '';
    public generationConditionLoadingId: string = '';
    public imageErrors: any = {};
    public filters: any = this.emptyFilters();
    public draftFilters: any = this.emptyFilters();
    public showExpertFilters: boolean = false;
    public filterValidationMessage: string = '';
    public readonly maxPeriodYear: number = new Date().getFullYear();
    public showAdvancedFilters: boolean = false;
    public showCollectionStatus: boolean = false;
    public readonly eraBuckets: any[] = [
        { value: 'all', label: '전체' },
        { value: '1960s', label: '1960년대' },
        { value: '1970s', label: '1970년대' },
        { value: '1980s', label: '1980년대' },
        { value: '1990s', label: '1990년대' },
        { value: '2000s', label: '2000년대' },
        { value: '2010s', label: '2010년대' },
        { value: '2020s', label: '2020년대' }
    ];
    private readonly featureAliases: Record<string, string[]> = {
        'place.street': ['골목', '도로', '교차로', '사거리', '차도'],
        'place.market': ['상점', '상가', '백화점', '점포', '노점'],
        'place.station': ['정류장', '기차역', '철도역', '지하철역'],
        'place.school': ['교실', '교정'],
        'place.hospital': ['한의원', '진료실', '응급실'],
        'place.factory': ['제철소', '발전소', '작업장'],
        'place.park': ['산책로'],
        'place.port': ['부두', '항만', '해안', '선착장'],
        'place.airport': ['비행장', '활주로'],
        'place.heritage': ['문화재', '유적', '사적지', '고택', '궁궐'],
        'object.bus': ['시내버스', '고속버스'],
        'object.train': ['열차', '지하철', '기관차'],
        'object.car': ['승용차', '택시', '트럭', '차량'],
        'object.aircraft': ['비행기', '헬기', '헬리콥터'],
        'object.ship': ['어선', '여객선', '유람선', '군함'],
        'object.bicycle': [],
        'object.bridge': ['다리', '대교', '육교'],
        'object.sign': ['표지판', '안내판', '현판', '교통표지'],
        'object.machine': ['설비', '탱크', '생산라인'],
        'object.monument': ['기념비', '기념탑', '추모비', '조형물'],
        'object.building': ['주택', '아파트', '빌딩', '청사', '가옥'],
        'situation.protest': ['농성', '행진', '데모'],
        'situation.ceremony': ['개막식', '준공식', '추모식', '축제'],
        'situation.construction': ['공사', '철거', '복구 작업'],
        'situation.work': ['노동', '제조', '근무'],
        'situation.trade': ['판매', '매매', '경매', '장사'],
        'situation.traffic': ['차량 통행', '운행', '출퇴근', '승차', '하차'],
        'situation.performance': ['연극', '콘서트', '무대'],
        'situation.disaster': ['화재', '홍수', '태풍', '침수', '지진', '붕괴'],
        'situation.gathering': ['군중', '행렬', '관람객', '참석자'],
        'situation.night_scene': ['밤거리', '밤의']
    };
    private readonly advancedFilterKeys: string[] = [
        'generation_fit', 'region', 'district', 'source_code',
        'korean_level', 'era_level', 'region_level', 'ai_reference_status',
        'period_start', 'period_end', 'media_type', 'intensity_level',
        'approval_status'
    ];
    private pollTimer: any = null;
    private searchSequence: number = 0;
    private overviewSequence: number = 0;
    private similaritySequence: number = 0;
    private similaritySummarySequence: number = 0;
    private similaritySummaryReferenceId: string = '';
    private similaritySummaryPayload: any = null;
    private statusRefreshing: boolean = false;
    private detailReturnFocus: HTMLElement | null = null;
    private readonly promptReferenceStorageKey = 'ptsd.referencePromptContext.v1';
    private readonly generationReferenceStorageKey = 'ptsd.referenceGenerationCondition.v1';
    private readonly contentPatientStorageKey = 'ptsd.contentPatientSelection.v1';

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        if (!this.can('reference.read') && !this.can('content.read')) {
            this.service.href('/access');
            return;
        }
        await this.bootstrap();
        this.pollTimer = window.setInterval(() => {
            if (this.hasRunningSource() && !this.searching && !document.hidden) {
                void this.refreshStatus();
            }
        }, 10000);
    }

    public ngOnDestroy() {
        if (this.pollTimer) window.clearInterval(this.pollTimer);
        this.pollTimer = null;
        this.searchSequence += 1;
        this.overviewSequence += 1;
        this.similaritySequence += 1;
        this.similaritySummarySequence += 1;
        this.statusRefreshing = false;
        this.detailReturnFocus = null;
        this.similaritySource = null;
        this.similarityCandidate = null;
        document.body.style.overflow = '';
    }

    private emptyFilters() {
        return {
            keyword: '',
            feature_tag: '',
            source_code: '',
            era_bucket: 'all',
            generation_fit: 'recommended',
            korean_level: 'all',
            era_level: 'all',
            region_level: 'all',
            region: '',
            district: '',
            ai_reference_status: '',
            period_start: '',
            period_end: '',
            media_type: '',
            intensity_level: '',
            approval_status: '',
            sort_by: 'year_desc'
        };
    }

    private emptyOverview() {
        return {
            checked_at: '',
            summary: {
                total: 0,
                allowed: 0,
                review_required: 0,
                blocked: 0,
                recommended: 0,
                review: 0,
                excluded: 0
            },
            sources: [],
            feature_tags: [],
            facets: { sources: [], eras: [], era_buckets: [], regions: [], districts: [], categories: [] }
        };
    }

    public can(permission: string) {
        const permissions = this.service.auth?.session?.permissions;
        return Array.isArray(permissions) && permissions.includes(permission);
    }

    public async bootstrap() {
        this.loading = true;
        this.errorMessage = '';
        await this.service.render();
        await this.search(true);
        this.loading = false;
        await this.service.render();
        void this.loadCatalog();
    }

    public async loadCatalog() {
        const requestSequence = ++this.overviewSequence;
        this.overviewLoading = true;
        this.overviewErrorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('catalog', {});
            if (requestSequence !== this.overviewSequence) return;
            if (code !== 200 || !data?.overview) {
                this.overviewErrorMessage = data?.message || '분류 정보를 불러오지 못했습니다.';
                return;
            }
            this.overview = data.overview;
        } catch (_error) {
            if (requestSequence !== this.overviewSequence) return;
            this.overviewErrorMessage = '분류 정보를 불러오지 못했습니다.';
        } finally {
            if (requestSequence === this.overviewSequence) {
                this.overviewLoading = false;
                await this.service.render();
            }
        }
    }

    public async search(
        resetPage: boolean = true,
        direction: string = '',
        cursor: string = '',
        targetPage: number = this.page
    ): Promise<boolean> {
        const requestedPage = resetPage ? 1 : Math.max(1, targetPage);
        const requestSequence = ++this.searchSequence;
        const request = {
            ...this.filters,
            page: requestedPage,
            dump: this.dump,
            cursor: resetPage ? '' : cursor,
            direction: resetPage ? '' : direction,
            include_total: resetPage ? '1' : '0'
        };
        this.searching = true;
        this.errorMessage = '';
        await this.service.render();
        try {
            const { code, data } = await wiz.call('search', request);
            if (requestSequence !== this.searchSequence) return false;
            if (code !== 200 || !data?.result) {
                this.errorMessage = data?.message || '레퍼런스 검색에 실패했습니다.';
                return false;
            }
            this.applyResult(data.result);
            return true;
        } catch (_error) {
            if (requestSequence !== this.searchSequence) return false;
            this.errorMessage = '레퍼런스 검색에 실패했습니다.';
            return false;
        } finally {
            if (requestSequence === this.searchSequence) {
                this.searching = false;
                await this.service.render();
            }
        }
    }

    public async refreshStatus() {
        if (this.statusRefreshing) return;
        this.statusRefreshing = true;
        try {
            const { code, data } = await wiz.call('status', {});
            if (code === 200 && data?.overview) {
                const previousSources = new Map(
                    (this.overview?.sources || []).map((source: any) => [source.source_code, source])
                );
                const sources = (data.overview.sources || []).map((source: any) => {
                    const previous: any = previousSources.get(source.source_code) || {};
                    return {
                        ...previous,
                        ...source,
                        asset_count: Number(previous.asset_count || 0)
                    };
                });
                this.overview = {
                    ...this.overview,
                    ...data.overview,
                    sources,
                    facets: this.overview?.facets || this.emptyOverview().facets
                };
                await this.service.render();
            }
        } catch (_error) {
        } finally {
            this.statusRefreshing = false;
        }
    }

    private applyResult(result: any) {
        this.rows = Array.isArray(result?.rows) ? result.rows : [];
        if (result?.total !== null && result?.total !== undefined) {
            this.total = Math.max(0, Number(result.total || 0));
        }
        this.page = Math.max(1, Number(result?.page || this.page));
        this.dump = Math.max(1, Number(result?.dump || this.dump));
        this.previousCursor = String(result?.previous_cursor || '');
        this.nextCursor = String(result?.next_cursor || '');
    }

    public async resetFilters() {
        this.filters = this.emptyFilters();
        this.draftFilters = { ...this.filters };
        this.filterValidationMessage = '';
        await this.search(true);
    }

    public async selectSource(sourceCode: string) {
        this.filters.source_code = this.filters.source_code === sourceCode ? '' : sourceCode;
        this.draftFilters.source_code = this.filters.source_code;
        await this.search(true);
    }

    public async selectEra(eraBucket: string) {
        if (this.searching || this.filters.era_bucket === eraBucket) return;
        this.filters.era_bucket = eraBucket;
        await this.search(true);
        document.getElementById('reference-keyword')?.focus();
    }

    public selectedEraLabel() {
        return this.eraBuckets.find((item: any) => item.value === this.filters.era_bucket)?.label || '전체';
    }

    public selectedFeatureLabel() {
        const key = String(this.filters.feature_tag || '');
        return (this.overview?.feature_tags || []).find((item: any) => item.key === key)?.label || key;
    }

    public cardFeatureTags(row: any) {
        const tags = Array.isArray(row?.feature_tags) ? row.feature_tags : [];
        const selectedKey = String(this.filters.feature_tag || '');
        if (!selectedKey) return tags.slice(0, 2);
        return [
            ...tags.filter((tag: any) => tag.key === selectedKey),
            ...tags.filter((tag: any) => tag.key !== selectedKey)
        ].slice(0, 2);
    }

    private featureTerms(item: any) {
        return [
            ...String(item.label || '').split('·'),
            ...(this.featureAliases[String(item.key || '')] || [])
        ];
    }

    public featureTagOptions() {
        const all = Array.isArray(this.overview?.feature_tags) ? this.overview.feature_tags : [];
        const query = String(this.filters.keyword || '').trim().toLocaleLowerCase('ko-KR');
        if (query) {
            return all.filter((item: any) =>
                String(item.label || '').toLocaleLowerCase('ko-KR').includes(query)
                || this.featureTerms(item).some((term: string) => term.toLocaleLowerCase('ko-KR').includes(query))
                || String(item.search_terms || '').toLocaleLowerCase('ko-KR').includes(query)
            ).slice(0, 8);
        }
        if (this.filters.era_bucket !== 'all') return [];
        const popular = [
            'object.bus', 'place.street', 'place.market', 'situation.protest',
            'situation.ceremony', 'situation.night_scene'
        ];
        return popular.map((key: string) => all.find((item: any) => item.key === key))
            .filter((item: any) => item && item.key !== this.filters.feature_tag);
    }

    public onFeatureKeywordChange(value: string) {
        this.filters.keyword = value;
        if (this.filters.feature_tag) this.filters.feature_tag = '';
        void this.service.render();
    }

    public async selectFeatureTag(key: string) {
        if (this.searching) return;
        this.filters.feature_tag = key;
        this.filters.keyword = '';
        await this.search(true);
    }

    public async submitFeatureSearch() {
        const query = String(this.filters.keyword || '').trim();
        const match = (this.overview?.feature_tags || []).find((item: any) =>
            item.label === query || this.featureTerms(item).includes(query)
        );
        if (match) {
            this.filters.feature_tag = match.key;
            this.filters.keyword = '';
        }
        await this.search(true);
    }

    public async exploreAllReferences() {
        if (this.searching || this.filters.generation_fit !== 'recommended') return;
        this.filters.generation_fit = 'all';
        this.draftFilters.generation_fit = 'all';
        await this.search(true);
    }

    public async toggleAdvancedFilters() {
        const closing = this.showAdvancedFilters;
        if (!closing) {
            this.draftFilters = { ...this.filters };
            this.filterValidationMessage = '';
            this.showExpertFilters = [
                'korean_level', 'era_level', 'region_level', 'ai_reference_status',
                'period_start', 'period_end', 'media_type', 'intensity_level',
                'approval_status'
            ].some((key: string) => this.filters[key] !== this.emptyFilters()[key]);
        }
        this.showAdvancedFilters = !this.showAdvancedFilters;
        await this.service.render();
        if (closing) document.getElementById('reference-advanced-toggle')?.focus();
    }

    public async toggleCollectionStatus() {
        this.showCollectionStatus = !this.showCollectionStatus;
        await this.service.render();
    }

    public activeFilterCount(): number {
        const defaults: any = this.emptyFilters();
        return Object.keys(defaults).filter((key: string) => key !== 'sort_by' && this.filters[key] !== defaults[key]).length;
    }

    public activeAdvancedFilterCount(): number {
        const defaults: any = this.emptyFilters();
        return this.advancedFilterKeys.filter((key: string) => this.filters[key] !== defaults[key]).length;
    }

    public regionOptions() {
        const preferredOrder = [
            '전국', '서울', '부산', '인천', '대전', '대구', '광주', '울산',
            '세종', '경기', '강원', '충북', '충남', '전북', '전남', '경북',
            '경남', '제주'
        ];
        const regions = (this.overview?.facets?.regions || [])
            .filter((item: any) => String(item?.value || '').trim()
                && (this.draftFilters.generation_fit === 'all'
                    ? Number(item.count || 0) > 0
                    : Number(item.recommended_count || 0) > 0))
            .map((item: any) => ({
                value: String(item.value),
                label: String(item.value),
                count: Math.max(0, Number(
                    this.draftFilters.generation_fit === 'all' ? item.count : item.recommended_count
                ))
            }))
            .sort((left: any, right: any) => {
                const leftIndex = preferredOrder.indexOf(left.value);
                const rightIndex = preferredOrder.indexOf(right.value);
                const leftRank = leftIndex < 0 ? preferredOrder.length : leftIndex;
                const rightRank = rightIndex < 0 ? preferredOrder.length : rightIndex;
                return leftRank - rightRank || left.label.localeCompare(right.label, 'ko-KR');
            });
        return [
            {
                value: '',
                label: '전체 지역',
                count: this.generationFitCount(this.draftFilters.generation_fit)
            },
            ...regions
        ];
    }

    public districtOptions() {
        const region = String(this.draftFilters.region || '');
        if (!region) return [];
        return (this.overview?.facets?.districts || [])
            .filter((item: any) => item.region === region && (
                this.draftFilters.generation_fit === 'all'
                    ? Number(item.count || 0) > 0
                    : Number(item.recommended_count || 0) > 0
            ))
            .map((item: any) => ({
                value: String(item.value),
                count: Number(this.draftFilters.generation_fit === 'all'
                    ? item.count : item.recommended_count) || 0
            }))
            .sort((left: any, right: any) => right.count - left.count
                || left.value.localeCompare(right.value, 'ko-KR'));
    }

    public selectDraftRegion(value: string) {
        this.draftFilters.region = value;
        this.draftFilters.district = '';
    }

    public selectDraftPurpose(value: string) {
        if (value !== 'recommended' && value !== 'all') return;
        this.draftFilters.generation_fit = value;
        if (value === 'recommended') this.draftFilters.ai_reference_status = '';
        if (this.draftFilters.region && !this.regionOptions().some((item: any) => item.value === this.draftFilters.region)) {
            this.draftFilters.region = '';
            this.draftFilters.district = '';
        }
    }

    public draftFiltersChanged() {
        return this.advancedFilterKeys.some((key: string) => this.draftFilters[key] !== this.filters[key]);
    }

    public resetAdvancedFilters() {
        const defaults = this.emptyFilters();
        this.advancedFilterKeys.forEach((key: string) => this.draftFilters[key] = defaults[key]);
        this.filterValidationMessage = '';
    }

    public resultActionLabel() {
        return this.draftFiltersChanged()
            ? '조건 적용해 결과 보기'
            : '결과 ' + this.formatNumber(this.total) + '건 보기';
    }

    public async applyAdvancedFilters() {
        const start = this.draftFilters.period_start;
        const end = this.draftFilters.period_end;
        const validYear = (value: any) => value === '' || (
            Number.isInteger(Number(value)) && Number(value) >= 1960
            && Number(value) <= this.maxPeriodYear
        );
        if (!validYear(start) || !validYear(end) || (start !== '' && end !== '' && Number(start) > Number(end))) {
            this.filterValidationMessage = '연도는 1960년부터 입력하고 시작 연도가 종료 연도보다 늦지 않게 해주세요.';
            this.showExpertFilters = true;
            await this.service.render();
            return;
        }
        this.filterValidationMessage = '';
        const next = { ...this.filters };
        this.advancedFilterKeys.forEach((key: string) => next[key] = this.draftFilters[key]);
        this.filters = next;
        const ok = await this.search(true);
        if (ok) {
            this.showAdvancedFilters = false;
            await this.service.render();
            document.getElementById('reference-results-title')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
            document.getElementById('reference-results-title')?.focus({ preventScroll: true });
        }
    }

    public appliedFilterChips() {
        const names: any = {
            keyword: '검색어', feature_tag: '특징', source_code: '자료원', region: '지역', district: '시·군·구',
            ai_reference_status: 'AI 입력', period_start: '시작',
            period_end: '종료', media_type: '유형', intensity_level: '강도',
            approval_status: '승인', korean_level: '한국성', era_level: '시대성',
            region_level: '지역성'
        };
        const defaults = this.emptyFilters();
        const levelLabels: any = { high: '높음', medium: '보통', low: '낮음', unclassified: '미분류' };
        const valueLabels: any = {
            image: '이미지', audio: '오디오', video: '영상',
            allowed: '원본 입력 가능', review_required: '입력 전 검토', blocked: '원본 입력 제외',
            pending: '검토 대기', approved: '승인', rejected: '반려', quarantined: '격리'
        };
        return Object.keys(names)
            .filter((key: string) => this.filters[key] !== defaults[key])
            .map((key: string) => ({
                key,
                label: names[key] + ' · ' + (key === 'feature_tag'
                    ? this.selectedFeatureLabel()
                    : key === 'source_code'
                        ? (this.overview?.sources || []).find((item: any) => item.source_code === this.filters[key])?.label || this.filters[key]
                        : ['korean_level', 'era_level', 'region_level'].includes(key)
                            ? levelLabels[this.filters[key]] || this.filters[key]
                            : key === 'intensity_level'
                                ? '강도 ' + this.filters[key]
                                : valueLabels[this.filters[key]] || String(this.filters[key]))
            }));
    }

    public async clearAppliedFilter(key: string) {
        const defaults = this.emptyFilters();
        if (!(key in defaults)) return;
        this.filters[key] = defaults[key];
        if (key === 'region') this.filters.district = '';
        this.draftFilters = { ...this.filters };
        await this.search(true);
    }

    public async previousPage() {
        if (
            this.page <= 1
            || this.searching
            || (this.usesCursorPagination() && !this.previousCursor)
        ) return;
        const moved = await this.search(
            false,
            this.usesCursorPagination() ? 'before' : '',
            this.usesCursorPagination() ? this.previousCursor : '',
            this.page - 1
        );
        if (moved) window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    public async nextPage() {
        if (
            this.page >= this.pageCount()
            || this.searching
            || (this.usesCursorPagination() && !this.nextCursor)
        ) return;
        const moved = await this.search(
            false,
            this.usesCursorPagination() ? 'after' : '',
            this.usesCursorPagination() ? this.nextCursor : '',
            this.page + 1
        );
        if (moved) window.scrollTo({ top: 0, behavior: 'smooth' });
    }

    public pageCount() {
        return Math.max(1, Math.ceil(this.total / Math.max(1, this.dump)));
    }

    public usesCursorPagination() {
        return (
            String(this.filters?.sort_by || 'year_desc') === 'year_desc'
            && !String(this.filters?.keyword || '').trim()
        );
    }

    public async openDetail(row: any) {
        this.detailReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.selected = row;
        this.resetSimilaritySummary();
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => document.getElementById('reference-detail-close')?.focus(), 0);
        void this.loadSimilaritySummary(row);
    }

    public async closeDetail() {
        this.resetSimilaritySummary();
        this.selected = null;
        document.body.style.overflow = '';
        await this.service.render();
        const target = this.detailReturnFocus;
        this.detailReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    private resetSimilaritySummary() {
        this.similaritySummarySequence += 1;
        this.similaritySummaryLoading = false;
        this.similaritySummaryCount = null;
        this.similaritySummaryError = '';
        this.similaritySummaryReferenceId = '';
        this.similaritySummaryPayload = null;
    }

    private apiResponse(response: any) {
        const envelope = response?.responseJSON || response || {};
        const parsedCode = Number(envelope?.code);
        return {
            code: Number.isFinite(parsedCode) ? parsedCode : 0,
            data: envelope?.data && typeof envelope.data === 'object'
                ? envelope.data
                : {}
        };
    }

    private similarityNotIndexed(code: number, data: any) {
        return code === 404
            && String(data?.message || '').includes('색인');
    }

    private normalizedSimilarityPayload(row: any, data: any) {
        return {
            source: data?.source || row,
            source_tag_keys: Array.isArray(data?.source_tag_keys)
                ? data.source_tag_keys
                    .map((value: any) => String(value || ''))
                    .filter(Boolean)
                : [],
            items: Array.isArray(data?.items) ? data.items : []
        };
    }

    private applySimilarityPayload(row: any, payload: any) {
        const normalized = this.normalizedSimilarityPayload(row, payload);
        this.similaritySource = normalized.source;
        this.similarityItems = normalized.items;
        this.similaritySourceTags = normalized.source_tag_keys;
        this.similarityCandidate = this.similarityItems[0] || null;
    }

    public async loadSimilaritySummary(row: any) {
        if (!row || !this.canSearchSimilar(row)) return;
        const referenceId = String(row?.id || '').trim().toLowerCase();
        if (!/^[0-9a-f]{32}$/.test(referenceId)) return;
        const requestSequence = ++this.similaritySummarySequence;
        this.similaritySummaryReferenceId = referenceId;
        this.similaritySummaryPayload = null;
        this.similaritySummaryCount = null;
        this.similaritySummaryError = '';
        this.similaritySummaryLoading = true;
        await this.service.render();
        try {
            const response: any = await wiz.call('similar', {
                reference_id: referenceId,
                limit: 40
            });
            if (requestSequence !== this.similaritySummarySequence) return;
            const { code, data } = this.apiResponse(response);
            if (code === 200 && Array.isArray(data?.items)) {
                const payload = this.normalizedSimilarityPayload(row, data);
                this.similaritySummaryPayload = payload;
                this.similaritySummaryCount = payload.items.length;
                return;
            }
            if (this.similarityNotIndexed(code, data)) {
                this.similaritySummaryPayload = this.normalizedSimilarityPayload(
                    row,
                    { source: row, items: [], source_tag_keys: [] }
                );
                this.similaritySummaryCount = 0;
                return;
            }
            this.similaritySummaryError = data?.message
                || '유사 레퍼런스 수를 확인하지 못했습니다.';
        } catch (_error) {
            if (requestSequence !== this.similaritySummarySequence) return;
            this.similaritySummaryError = '유사 레퍼런스 수를 확인하지 못했습니다.';
        } finally {
            if (requestSequence === this.similaritySummarySequence) {
                this.similaritySummaryLoading = false;
                await this.service.render();
            }
        }
    }

    public canSearchSimilar(row: any) {
        return String(row?.ai_reference_status || '') === 'allowed';
    }

    public canReuseReference(row: any) {
        return this.can('prompts.manage')
            && this.isApprovedRecommendedReference(row);
    }

    public canUseGenerationCondition(row: any) {
        return this.can('content.write')
            && this.isApprovedRecommendedReference(row);
    }

    public isApprovedRecommendedReference(row: any) {
        return String(row?.ai_reference_status || '') === 'allowed'
            && String(row?.generation_fit_status || '') === 'recommended';
    }

    public async openSimilarity(row: any) {
        if (!row || !this.canSearchSimilar(row)) return;
        const requestSequence = ++this.similaritySequence;
        this.similaritySource = row;
        this.similarityCandidate = null;
        this.similarityItems = [];
        this.similaritySourceTags = [];
        this.similarityLoading = true;
        this.similarityError = '';
        this.similaritySort = 'score';
        this.similaritySameEraOnly = false;
        this.similaritySameRegionOnly = false;
        this.similaritySharedTagsOnly = false;
        this.selected = null;
        document.body.style.overflow = 'hidden';
        await this.service.render();
        setTimeout(() => document.getElementById('reference-similarity-close')?.focus(), 0);
        const referenceId = String(row?.id || '').trim().toLowerCase();
        if (
            this.similaritySummaryReferenceId === referenceId
            && this.similaritySummaryPayload
            && this.similaritySummaryCount !== null
        ) {
            this.applySimilarityPayload(row, this.similaritySummaryPayload);
            this.similarityLoading = false;
            await this.service.render();
            return;
        }
        try {
            const response: any = await wiz.call('similar', {
                reference_id: referenceId,
                limit: 40
            });
            if (requestSequence !== this.similaritySequence) return;
            const { code, data } = this.apiResponse(response);
            if (code !== 200 || !Array.isArray(data?.items)) {
                if (this.similarityNotIndexed(code, data)) {
                    this.applySimilarityPayload(row, {
                        source: row,
                        items: [],
                        source_tag_keys: []
                    });
                    return;
                }
                this.similarityError = data?.message || '유사 레퍼런스를 검색하지 못했습니다.';
                return;
            }
            const payload = this.normalizedSimilarityPayload(row, data);
            this.applySimilarityPayload(row, payload);
            this.similaritySummaryReferenceId = referenceId;
            this.similaritySummaryPayload = payload;
            this.similaritySummaryCount = payload.items.length;
        } catch (_error) {
            if (requestSequence !== this.similaritySequence) return;
            this.similarityError = '유사 레퍼런스를 검색하지 못했습니다.';
        } finally {
            if (requestSequence === this.similaritySequence) {
                this.similarityLoading = false;
                await this.service.render();
            }
        }
    }

    public async closeSimilarity(restoreDetail: boolean = true) {
        const source = this.similaritySource;
        this.similaritySequence += 1;
        this.similaritySource = null;
        this.similarityCandidate = null;
        this.similarityItems = [];
        this.similaritySourceTags = [];
        this.similarityLoading = false;
        this.similarityError = '';
        this.selected = restoreDetail ? source : null;
        if (!restoreDetail) document.body.style.overflow = '';
        await this.service.render();
        if (restoreDetail && source) {
            setTimeout(() => document.getElementById('reference-similar-open')?.focus(), 0);
        } else {
            const target = this.detailReturnFocus;
            this.detailReturnFocus = null;
            setTimeout(() => target?.focus(), 0);
        }
    }

    public async openSimilarityCandidateDetail() {
        const candidate = this.similarityCandidate;
        if (!candidate) return;
        this.similaritySequence += 1;
        this.resetSimilaritySummary();
        this.similaritySource = null;
        this.similarityCandidate = null;
        this.similarityItems = [];
        this.similaritySourceTags = [];
        this.selected = candidate;
        await this.service.render();
        setTimeout(() => document.getElementById('reference-detail-close')?.focus(), 0);
        void this.loadSimilaritySummary(candidate);
    }

    public selectSimilarityCandidate(row: any) {
        this.similarityCandidate = row;
        void this.service.render();
    }

    public sharedSemanticTags(row: any) {
        const source = new Set(this.similaritySourceTags);
        const values = Array.isArray(row?.semantic_tags) ? row.semantic_tags : [];
        return values
            .map((value: any) => String(value || ''))
            .filter((value: string) => value && source.has(value));
    }

    public sharedTagCount(row: any) {
        return this.sharedSemanticTags(row).length;
    }

    public similarityVisibleItems() {
        const source = this.similaritySource || {};
        const rows = this.similarityItems.filter((row: any) => {
            if (
                this.similaritySameEraOnly
                && String(row?.era_bucket || '') !== String(source?.era_bucket || '')
            ) return false;
            if (
                this.similaritySameRegionOnly
                && String(row?.region || '') !== String(source?.region || '')
            ) return false;
            if (this.similaritySharedTagsOnly && this.sharedTagCount(row) === 0) return false;
            return true;
        });
        const score = (row: any) => Number(row?.similarity_score || 0);
        const sameEra = (row: any) => Number(
            !!source?.era_bucket && row?.era_bucket === source.era_bucket
        );
        const sameRegion = (row: any) => Number(
            !!source?.region && row?.region === source.region
        );
        return [...rows].sort((left: any, right: any) => {
            if (this.similaritySort === 'tags') {
                return this.sharedTagCount(right) - this.sharedTagCount(left)
                    || score(right) - score(left);
            }
            if (this.similaritySort === 'era') {
                return sameEra(right) - sameEra(left) || score(right) - score(left);
            }
            if (this.similaritySort === 'region') {
                return sameRegion(right) - sameRegion(left) || score(right) - score(left);
            }
            return score(right) - score(left);
        });
    }

    public onSimilarityCriteriaChange() {
        const rows = this.similarityVisibleItems();
        if (!rows.some((row: any) => row?.id === this.similarityCandidate?.id)) {
            this.similarityCandidate = rows[0] || null;
        }
        void this.service.render();
    }

    public similarityPercent(value: any) {
        const numeric = Number(value || 0);
        if (!Number.isFinite(numeric)) return '0%';
        return Math.round(Math.max(0, Math.min(1, numeric)) * 100) + '%';
    }

    public semanticTagLabel(value: any) {
        const labels: any = {
            'region.korea': '한국',
            'era.historical': '역사 시대',
            'era.modern': '현대',
            'visual.architecture': '건축물',
            'visual.street': '거리',
            'visual.transportation': '교통',
            'visual.railway': '철도',
            'visual.aviation': '항공',
            'visual.maritime': '항구·해양',
            'visual.nature': '자연',
            'visual.industrial': '산업',
            'visual.commercial': '상업',
            'visual.monument': '기념물',
            'visual.artifact': '유물',
            'visual.interior': '실내',
            'visual.people': '인물',
            'visual.crowded': '군중',
            'visual.wide_shot': '전경',
            'visual.close_up': '근접',
            'environment.indoor': '실내 환경',
            'environment.outdoor': '야외 환경',
            'environment.urban': '도시',
            'environment.rural': '농어촌'
        };
        const key = String(value || '');
        if (labels[key]) return labels[key];
        const suffix = key.split('.').slice(1).join(' · ').replace(/_/g, ' ');
        return suffix || key;
    }

    public onSimilarityKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeSimilarity(true);
            return;
        }
        if (event.key !== 'Tab') return;
        const dialog = document.getElementById('reference-similarity-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (!focusable.length) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public onDetailKeydown(event: KeyboardEvent) {
        if (event.key === 'Escape') {
            event.preventDefault();
            void this.closeDetail();
            return;
        }
        if (event.key !== 'Tab') return;

        const dialog = document.getElementById('reference-detail-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    public markImageError(url: any) {
        const key = String(url || '');
        if (!key) return;
        this.imageErrors[key] = true;
        void this.service.render();
    }

    public imageFailed(url: any) {
        const key = String(url || '');
        return !!key && this.imageErrors[key] === true;
    }

    public imageUrl(row: any) {
        const thumbnail = String(row?.thumbnail_url || '');
        const image = String(row?.image_url || '');
        if (thumbnail && !this.imageFailed(thumbnail)) return thumbnail;
        if (image && !this.imageFailed(image)) return image;
        return '';
    }

    public detailImageUrl(row: any) {
        const image = String(row?.image_url || '');
        const thumbnail = String(row?.thumbnail_url || '');
        if (image && !this.imageFailed(image)) return image;
        if (thumbnail && !this.imageFailed(thumbnail)) return thumbnail;
        return '';
    }

    public hasRunningSource() {
        return (this.overview?.sources || []).some((source: any) => source.status === 'running');
    }

    public progress(source: any) {
        const total = Math.max(0, Number(source?.total_estimate || 0));
        const seen = Math.max(0, Number(source?.assets_seen || 0));
        if (!total) return 0;
        return Math.min(100, Math.round((seen / total) * 100));
    }

    public formatNumber(value: any) {
        return Math.max(0, Number(value || 0)).toLocaleString('ko-KR');
    }

    public dateTime(value: any) {
        const text = String(value || '').replace('T', ' ').replace('Z', '');
        return text ? text.slice(0, 16) : '-';
    }

    public sourceStatusLabel(value: string) {
        const labels: any = {
            not_started: '수집 전',
            idle: '대기',
            running: '수집 중',
            partial: '이어받기 대기',
            succeeded: '수집 완료',
            failed: '수집 오류',
            cancelled: '취소됨',
            tls_blocked: 'TLS 연결 보류'
        };
        return labels[value] || value || '수집 전';
    }

    public sourceStatusClass(value: string) {
        if (value === 'succeeded') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
        if (value === 'running') return 'bg-sky-50 text-sky-700 border-sky-200';
        if (value === 'tls_blocked' || value === 'failed') return 'bg-amber-50 text-amber-800 border-amber-200';
        return 'bg-slate-50 text-slate-600 border-slate-200';
    }

    public rightsLabel(value: string) {
        const labels: any = {
            allowed: 'AI 원본 입력 가능',
            review_required: 'AI 원본 입력 전 검토',
            blocked: 'AI 원본 입력 제외'
        };
        return labels[value] || 'AI 원본 입력 전 검토';
    }

    public rightsClass(value: string) {
        if (value === 'allowed') return 'bg-emerald-50 text-emerald-700 border-emerald-200';
        if (value === 'blocked') return 'bg-rose-50 text-rose-700 border-rose-200';
        return 'bg-amber-50 text-amber-800 border-amber-200';
    }

    public eraBucketLabel(value: any) {
        const key = String(value || 'unknown');
        const option = this.eraBuckets.find((item: any) => item.value === key);
        const historicalLabels: any = {
            pre_1876: '개항 이전',
            opening_empire: '개항기·대한제국',
            colonial: '일제강점기',
            liberation_1950s: '광복·1950년대',
            unknown: '연대 미상'
        };
        return option?.label || historicalLabels[key] || key;
    }

    public rowEraLabel(row: any) {
        const bucket = String(row?.era_bucket || '');
        if (bucket) return this.eraBucketLabel(bucket);
        return String(row?.era_label || row?.year_label || '연대 미상');
    }

    public generationFitLabel(value: any) {
        const labels: any = {
            all: '전체 자료',
            recommended: '추천 레퍼런스',
            review: '검토 필요',
            excluded: '생성 입력 제외',
            pending: '분류 대기',
            failed: '분류 확인 필요'
        };
        return labels[String(value || '')] || '분류 대기';
    }

    public generationFitClass(value: any) {
        const status = String(value || '');
        if (status === 'recommended') {
            return 'border-emerald-200 bg-emerald-50 text-emerald-700';
        }
        if (status === 'excluded') {
            return 'border-rose-200 bg-rose-50 text-rose-700';
        }
        if (status === 'review') {
            return 'border-amber-200 bg-amber-50 text-amber-800';
        }
        return 'border-slate-200 bg-slate-50 text-slate-600';
    }

    public generationFitCount(value: any) {
        const key = String(value || 'recommended');
        if (key === 'all') return Number(this.overview?.summary?.total || 0);
        return Number(this.overview?.summary?.[key] || 0);
    }

    public scoreText(value: any) {
        if (value === null || value === undefined || value === '') return '미분류';
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return '미분류';
        return Math.round(Math.max(0, Math.min(100, numeric))) + '점';
    }

    public scoreClass(value: any) {
        if (value === null || value === undefined || value === '') {
            return 'bg-slate-100 text-slate-500';
        }
        const numeric = Number(value);
        if (!Number.isFinite(numeric)) return 'bg-slate-100 text-slate-500';
        if (numeric >= 70) return 'bg-emerald-50 text-emerald-700';
        if (numeric >= 40) return 'bg-amber-50 text-amber-800';
        return 'bg-rose-50 text-rose-700';
    }

    public faceStatusLabel(value: any) {
        const labels: any = {
            person_centered_metadata: '메타데이터상 인물 중심',
            event_people_metadata: '메타데이터상 행사·인물',
            not_assessed: '이미지 얼굴 미판정'
        };
        return labels[String(value || 'not_assessed')] || '이미지 얼굴 미판정';
    }

    public classificationMethodLabel(value: any) {
        const labels: any = {
            metadata_v1: '메타데이터 규칙 v1',
            metadata_v2: '촬영 시대 분리 규칙 v2',
            automatic: '자동 분류',
            model: 'AI 자동 분류',
            rule: '규칙 기반 분류',
            manual: '수동 검토',
            hybrid: '자동 분류 후 검토'
        };
        return labels[String(value || '')] || String(value || '분류 방법 미상');
    }

    public promptReferenceSummary(row: any) {
        const values = [
            this.rowEraLabel(row),
            String(row?.region || '').trim(),
            String(row?.district || '').trim(),
            String(row?.category || '').trim()
        ].filter((value: string, index: number, items: string[]) =>
            !!value && value !== '-' && value !== '연대 미상' && items.indexOf(value) === index
        );
        return values.length ? values.join(' · ') : '분류된 시대·지역 정보가 없습니다.';
    }

    private promptContextFromRow(row: any) {
        const referenceId = String(row?.id || '').trim().toLowerCase();
        if (
            !/^[0-9a-f]{32}$/.test(referenceId)
            || !this.isApprovedRecommendedReference(row)
        ) return null;
        return {
            schema_version: 1,
            reference_id: referenceId,
            title: String(row?.title || '').slice(0, 255),
            source_label: String(row?.source_label || '').slice(0, 120),
            source_url: String(row?.source_url || '').slice(0, 1000),
            source_credit: String(
                row?.source_credit || row?.source_label || ''
            ).slice(0, 255),
            era_label: String(
                row?.era_label || row?.year_label || '연대 미상'
            ).slice(0, 80),
            region: String(row?.region || '').slice(0, 80),
            district: String(row?.district || '').slice(0, 80),
            category: String(row?.category || '').slice(0, 120)
        };
    }

    private generationConditionFromRow(row: any) {
        const referenceId = String(row?.id || '').trim().toLowerCase();
        if (
            !/^[0-9a-f]{32}$/.test(referenceId)
            || !this.isApprovedRecommendedReference(row)
        ) return null;
        return {
            schema_version: 1,
            reference_id: referenceId,
            title: String(row?.title || '').slice(0, 255),
            source_label: String(row?.source_label || '').slice(0, 120),
            era_bucket: String(row?.era_bucket || '').slice(0, 32),
            era_label: String(
                row?.era_label || row?.year_label || '연대 미상'
            ).slice(0, 80),
            region: String(row?.region || '').slice(0, 80),
            district: String(row?.district || '').slice(0, 80),
            category: String(row?.category || '').slice(0, 120),
            tags: Array.isArray(row?.tags)
                ? row.tags
                    .map((value: any) => String(value || '').slice(0, 80))
                    .filter(Boolean)
                    .slice(0, 30)
                : [],
            preview_thumbnail_url: this.publicReferenceImageUrl(
                row?.thumbnail_url
            ),
            preview_image_url: this.publicReferenceImageUrl(row?.image_url),
            original_image_transmitted: false
        };
    }

    private publicReferenceImageUrl(value: any) {
        const url = String(value || '').trim().slice(0, 1000);
        if (!/^https?:\/\//i.test(url)) return '';
        try {
            const parsed = new URL(url);
            return ['http:', 'https:'].includes(parsed.protocol) ? url : '';
        } catch (_error) {
            return '';
        }
    }

    private contentPatientIdForHandoff() {
        let routeValue = '';
        try {
            routeValue = String(
                new URLSearchParams(window.location.search).get('patient_id') || ''
            ).trim().toLowerCase();
        } catch (_error) {
        }
        if (/^[0-9a-f]{32}$/.test(routeValue)) {
            try {
                window.sessionStorage.setItem(
                    this.contentPatientStorageKey,
                    routeValue
                );
            } catch (_error) {
            }
            return routeValue;
        }
        try {
            const remembered = String(
                window.sessionStorage.getItem(this.contentPatientStorageKey) || ''
            ).trim().toLowerCase();
            return /^[0-9a-f]{32}$/.test(remembered) ? remembered : '';
        } catch (_error) {
        }
        return '';
    }

    private contentSourceQueryForHandoff() {
        try {
            const params = new URLSearchParams(window.location.search);
            const source = String(params.get('source') || '').trim().toLowerCase();
            const scenario = String(params.get('scenario') || '').trim().toUpperCase();
            const memory = String(params.get('memory') || '').trim().toLowerCase();
            if (
                source === 'scenario'
                && /^(?:[A-Z]{2}-[0-9]{2}|[A-Z][0-9]{2}|IM[0-9A-F]{14})$/.test(scenario)
                && ['trauma', 'positive'].includes(memory)
            ) {
                return '&source=scenario'
                    + '&scenario=' + encodeURIComponent(scenario)
                    + '&memory=' + encodeURIComponent(memory);
            }
        } catch (_error) {
        }
        const patientId = this.contentPatientIdForHandoff();
        return patientId
            ? '&patient_id=' + encodeURIComponent(patientId)
            : '';
    }

    public contentReturnUrl() {
        const sourceQuery = this.contentSourceQueryForHandoff();
        return '/content' + (sourceQuery ? '?' + sourceQuery.slice(1) : '');
    }

    public showContentReturnButton() {
        try {
            const params = new URLSearchParams(window.location.search);
            return String(params.get('from') || '').trim().toLowerCase() === 'content';
        } catch (_error) {
            return false;
        }
    }

    public async sendReferenceToPrompts(row: any) {
        if (!row || !this.canReuseReference(row) || this.reuseLoadingId) return;
        const referenceId = String(row?.id || '');
        this.reuseLoadingId = referenceId;
        await this.service.render();
        let ready = false;
        try {
            let context: any = this.promptContextFromRow(row);
            try {
                const response: any = await wiz.call('reuse_context', {
                    reference_id: referenceId
                });
                const { code, data } = this.apiResponse(response);
                if (code === 200 && data?.context) {
                    context = data.context;
                } else if (
                    code > 0
                    && (code !== 404 || !!data?.message)
                ) {
                    await this.service.modal.error(
                        data?.message || '프롬프트 참고정보를 준비하지 못했습니다.'
                    );
                    return;
                }
            } catch (_error) {
                // Prompt context contains only public metadata from the archive row.
                // Keep the handoff available while a new read-only endpoint reaches
                // the current WIZ worker; prompt save still sanitizes every field.
            }
            if (!context) {
                await this.service.modal.error(
                    '프롬프트 참고정보를 준비하지 못했습니다.'
                );
                return;
            }
            try {
                window.sessionStorage.setItem(
                    this.promptReferenceStorageKey,
                    JSON.stringify(context)
                );
            } catch (_error) {
                await this.service.modal.error(
                    '브라우저에 프롬프트 참고정보를 저장하지 못했습니다. '
                    + '사이트 저장소 설정을 확인해주세요.'
                );
                return;
            }
            ready = true;
        } finally {
            this.reuseLoadingId = '';
            await this.service.render();
        }
        if (!ready) return;
        document.body.style.overflow = '';
        this.service.href('/prompts?reference_context=1');
    }

    public async sendReferenceToGeneration(row: any) {
        if (
            !row
            || !this.canUseGenerationCondition(row)
            || this.generationConditionLoadingId
        ) return;
        const referenceId = String(row?.id || '');
        this.generationConditionLoadingId = referenceId;
        await this.service.render();
        let ready = false;
        try {
            let context: any = this.generationConditionFromRow(row);
            try {
                const response: any = await wiz.call('generation_context', {
                    reference_id: referenceId
                });
                const envelope = response?.responseJSON || response || {};
                const code = envelope?.code;
                const data = envelope?.data;
                if (code === 200 && data?.context) {
                    context = {
                        ...context,
                        ...data.context
                    };
                } else if (
                    typeof code === 'number'
                    && (code !== 404 || !!data?.message)
                ) {
                    await this.service.modal.error(
                        data?.message || '생성 조건 레퍼런스를 준비하지 못했습니다.'
                    );
                    return;
                }
            } catch (_error) {
                // The content API revalidates the reference id before every generation.
                // Keep the handoff available when a newly deployed read-only context
                // endpoint has not reached the current WIZ worker yet.
            }
            if (!context) {
                await this.service.modal.error('생성 조건 레퍼런스를 준비하지 못했습니다.');
                return;
            }
            try {
                window.sessionStorage.setItem(
                    this.generationReferenceStorageKey,
                    JSON.stringify(context)
                );
            } catch (_error) {
                await this.service.modal.error(
                    '브라우저에 생성 조건을 저장하지 못했습니다. '
                    + '사이트 저장소 설정을 확인해주세요.'
                );
                return;
            }
            ready = true;
        } finally {
            this.generationConditionLoadingId = '';
            await this.service.render();
        }
        if (!ready) return;
        document.body.style.overflow = '';
        this.service.href(
            '/content?reference_condition=1'
            + this.contentSourceQueryForHandoff()
        );
    }

    public trackById(_index: number, row: any) {
        return row?.id;
    }
}

export default PageReferencesComponent;